<template>
  <div>
    <v-overlay :value="isLoading" opacity="0.8">
    <v-progress-circular
        v-if="isLoading"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
        class="centered"
    />
    </v-overlay>
    <h1 class="text-center mt-3">
      ยกเลิกการเชื่อมต่อกับบัญชี Official Website
    </h1>

    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <BrandDropdown
              v-model="brandSelected"
              @setBrand="setBrand"
              @setBrands="setBrands"
              :setDisable="true"
          />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label for="customerNumber">Brand.com customer number</label>
          <input v-model="form.customerNumber" type="text" class="form-control bg-light" disabled />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label for="customerCode">B-Con customer code</label>
          <input v-model="form.customerCode" type="text" class="form-control bg-light" disabled />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label for="customerMobile">Customer mobile</label>
          <input v-model="form.customerMobile" type="text" class="form-control bg-light" disabled />
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <label for="file">Attached file <span class="text-danger">*</span></label>

          <div v-if="!isRevoke" class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text choose-btn-disabled"> Choose file</span>
            </div>
            <input
                type="text"
                class="form-control bg-light file-link"
                :value="fileName"
                readonly
                @click="openFile"
            />
          </div>

          <div v-else class="d-flex">
            <input
                id="importedFile"
                type="file"
                class="form-control"
                ref="importSurveyDataFile"
                @change="onFileChange"
                :disabled="isFileLoading"
                :class="{
                'input--error': isSubmit && error.errorResultPath,
              }"
            />
          </div>

          <div v-if="isSubmit && error.errorResultPath" class="text-error">
            {{ error.errorResultPath.message }}
          </div>
        </div>
      </div>

      <div class="mb-4">
        <label for="remark">Remark <span class="text-danger">*</span></label>
        <textarea
            v-model="form.remark"
            rows="4"
            class="form-control"
            :disabled="!isRevoke"
            :class="{
            'input--error': isSubmit && error.errorRemark,
          }"
        />
        <div v-if="isSubmit && error.errorRemark" class="text-error">
          {{ error.errorRemark.message }}
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <button v-if="id" class="btn btn-outline-secondary mr-2" @click="$router.back()">
          Back
        </button>

        <template v-else>
          <button class="btn btn-outline-danger mr-2" @click="$router.back()">
            Cancel
          </button>
          <button class="btn btn-outline-success" @click="showDialog = true">
            OK
          </button>
        </template>
      </div>
    </div>

    <v-dialog v-model="showDialog" width="550" persistent>
      <div class="confirm-dialog">
        <p>คุณแน่ใจใช่ไหมว่าต้องการยกเลิกการเชื่อมต่อบัญชี?</p>
        <span>
          การยกเลิกจะทำให้ประวัติการสั่งซื้อสินค้าของลูกค้าบน Official Website ถูกลบและคะแนนสะสมทั้งหมดจะถูกตัดออกทันที
        </span>

        <div class="button-container">
          <button class="btn btn-outline-secondary mr-2" @click="showDialog = false">ยกเลิก</button>
          <button class="btn btn-outline-success" @click="onSubmit">ยืนยัน</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import OfficialWebsiteService from "services/api/officialWebsite.service";
import BrandDropdown from "components/Brand/BrandDropdown.vue";
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";

export default {
  name: "UserRevocationDetail",
  components: { BrandDropdown },
  data() {
    return {
      isLoading: false,
      isFileLoading: false,
      isSubmit: false,
      brandSelected: null,
      brandOptions: [],
      id: this.$route.query.id || null,
      customerNumber: this.$route.query.customerNumber || null,
      brandCode: this.$route.query.brandCode || null,
      isRevoke: this.$route.params.isRevoke,
      form: {
        customerCode: null,
        customerNumber: null,
        customerMobile: null,
        remark: null,
        brandCode: null,
      },
      filePath: null,
      showDialog: false,
      message: "",
      error: {
        errorRemark: null,
        errorResultPath: null,
      },
    };
  },
  computed: {
    fileName() {
      return this.filePath ? this.filePath.split("/").pop() : "";
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      if (this.isRevoke) {
        await this.getUserMappingDetail();
      } else {
        await this.getUserRevocationsDetail();
      }
    },

    async getUserRevocationsDetail() {
      this.isLoading = true;
      try {
        const res = await OfficialWebsiteService.getUserRevocationsDetail(
            this.id
        );
        const data = res.data;

        this.form.customerCode = data.customerCode;
        this.form.customerNumber = data.customerNumber;
        this.form.customerMobile = data.phoneNumber;
        this.form.remark = data.remark || "";
        this.form.brandCode = data.brandCode;
        this.filePath = data.fileUrl || null;
        this.setBrand(data.brandCode);
      } catch (err) {
        this.handleError(err);
      } finally {
        this.isLoading = false;
      }
    },

    async getUserMappingDetail() {
      this.isLoading = true;
      try {
        const res = await OfficialWebsiteService.getUserMappingDetail(
            this.customerNumber,
            this.brandCode
        );
        const data = res.data;

        this.form.customerCode = data.customerCode;
        this.form.customerNumber = data.customerNumber;
        this.form.customerMobile = data.phoneNumber;
        this.form.brandCode = data.brandCode;

        this.setBrand(data.brandCode);
      } catch (err) {
        this.handleError(err);
      } finally {
        this.isLoading = false;
      }
    },

    openFile() {
      if (!this.filePath) return;
      window.open(this.filePath, "_blank");
    },

    findBrandByCode(code) {
      if (!code || !this.brandOptions.length) return null;
      return (
          this.brandOptions.find(
              (b) => b.id === code || b.code === code || b.brandCode === code
          ) || null
      );
    },

    ensureBrandSelected() {
      const code =
          (typeof this.brandSelected === "string" && this.brandSelected) ||
          this.form.brandCode ||
          this.brandCode;

      if (!code) return;

      const found = this.findBrandByCode(code);
      if (found) {
        this.brandSelected = found;
        this.form.brandCode = found.id || found.code || found.brandCode;
      }
    },

    setBrand(brand) {
      if (brand === null || brand === undefined || brand === "") {
        return;
      }

      if (typeof brand === "string") {
        this.form.brandCode = brand;
        const found = this.findBrandByCode(brand);
        this.brandSelected = found || brand;
        return;
      }

      this.brandSelected = brand;
      this.form.brandCode =
          brand.id || brand.code || brand.brandCode || this.form.brandCode;
    },

    setBrands(brands) {
      this.brandOptions = brands || [];
      this.ensureBrandSelected();
    },

    onFileChange(e) {
      this.error.errorResultPath = null;
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.getPresignURL(file);
    },

    async getPresignURL(file) {
      this.isFileLoading = true;
      this.isLoading = true;
      try {
        const res = await PresignedUploadUrlService.getS3SignUrl(
            "officialWebsite",
            file
        );
        const data = res.data;
        this.filePath = data.key;
        await this.updatePhotoToS3(data.presignedUrl, file);
      } catch (err) {
        console.log("Error: ", err.response || err);
      } finally {
        this.isLoading = false;
        this.isFileLoading = false;
      }
    },

    async updatePhotoToS3(url, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(url, file);
    },

    async onSubmit() {
      this.isSubmit = true;
      this.showDialog = false;
      this.resetErrorText();

      try {
        this.isLoading = true;
        const form = this.form;

        const body = {
          brandCode: form.brandCode,
          customerCode: form.customerCode,
          customerNumber: form.customerNumber,
          phoneNumber: form.customerMobile,
          key: this.filePath,
          remark: form.remark,
        };

        const res = await OfficialWebsiteService.revokeUserMapping(body);
        const payload = res && res.data;

        if (payload && Array.isArray(payload.deductedPoints)) {
          sessionStorage.setItem(
              "lastDeductedPoints",
              JSON.stringify(payload.deductedPoints)
          );
        }

        if (this.$refs.importSurveyDataFile) {
          this.$refs.importSurveyDataFile.value = null;
        }
        this.filePath = null;

        await this.$router.push({
          name: "UserRevocations",
          query: { showDeductedDialog: true },
        });
      } catch (err) {
        this.handleError(err);
        this.showDialog = false;
      } finally {
        this.isLoading = false;
      }
    },

    handleError(err) {
      const errorData = err.response?.data;
      if (errorData?.errors?.length > 0) {
        this.setErrorText(errorData.errors);
      } else if (errorData?.message) {
        alert(errorData.message);
      }
    },

    setErrorText(errors) {
      this.error.errorRemark =
          errors.find((e) => e.fieldName === "remark") || null;
      this.error.errorResultPath =
          errors.find((e) => e.fieldName === "key") || null;
    },

    resetErrorText() {
      this.error = {
        errorRemark: null,
        errorResultPath: null,
      };
    },
  },
};
</script>

<style scoped>
.form {
  max-width: 960px;
  margin: 0 auto;
}

.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}

.text-error {
  color: #dc3545;
  font-size: 0.875rem;
}

.input--error {
  border-color: #dc3545;
}

.file-link {
  cursor: pointer;
}
.file-link:read-only {
  background-color: #f8f9fa;
}

.choose-btn-disabled{
  background-color: #e9ecef;
  color: #495057;
  cursor: not-allowed;
  border: 1px solid #ced4da;
}

.confirm-dialog {
  background: #fff;
  padding: 2rem 2rem;
  height: 250px;
  position: relative;

  p {
    font-size: 20px;
    font-weight: bold;
  }

  .button-container {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
  }

}
</style>
